module["exports"] = [
  "###-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/address/postcode.js
// module id = 1463
// module chunks = 1